import { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import { ISelectEventItemProps } from './interfaces';
import { format } from 'date-fns';
import { convertUnixTimeToMilliSeconds } from '@helpers/events';
import { IEvent } from '@interfaces/event';
import SelectEventItemView from './SelectEventItemView';

const SelectEventItem = ({
  event,
  isSelectedEvent,
  setSelectedEvent,
  showDateBar = false,
  t: translate,
}: ISelectEventItemProps) => {
  const [eventTooptipOpen, setEventTooptipOpen] = useState(false);
  const [eventTooptipNameOpen, setEventTooptipNameOpen] = useState(false);

  const handleTooltipClose = () => {
    if (isMobileOnly) {
      setEventTooptipOpen(false);
      setEventTooptipNameOpen(false);
    }
  };

  const handleEventTooltipOpen = () => {
    if (isMobileOnly) {
      setEventTooptipOpen(true);
      setEventTooptipNameOpen(false);
    }
  };

  const handleEventNameTooltipOpen = () => {
    if (isMobileOnly) {
      setEventTooptipNameOpen(true);
      setEventTooptipOpen(false);
    }
  };

  const getTooltipText = (event: IEvent): string => {
    if (event.isFirstTimeTooltip) {
      return translate('eventPage.eventFirstTimeUnavailable');
    }

    if (event.isNotAvailableForGradeCodeTooltip) {
      return translate('eventPage.eventUnavailableToGradeCode');
    }

    if (event.isScheduled) {
      const startTime =
        event.inviteStartTime && event.inviteStartTime > 0
          ? event.inviteStartTime
          : event.startTime;

      const formattedDate = format(
        new Date(convertUnixTimeToMilliSeconds(startTime)),
        "HH:mm 'on' dd/MM/yyyy z",
      );

      return `${translate('eventPage.scheduledToolTip')} ${formattedDate}`;
    }

    return translate('eventPage.eventUnavailable');
  };

  const tooltipText = getTooltipText(event);

  return (
    <SelectEventItemView
      event={event}
      isSelectedEvent={isSelectedEvent}
      setSelectedEvent={setSelectedEvent}
      showDateBar={showDateBar}
      eventTooptipNameOpen={eventTooptipNameOpen}
      handleEventNameTooltipOpen={handleEventNameTooltipOpen}
      eventTooptipOpen={eventTooptipOpen}
      handleEventTooltipOpen={handleEventTooltipOpen}
      handleTooltipClose={handleTooltipClose}
      tooltipText={tooltipText}
    />
  );
};

export default withTranslation()(SelectEventItem);
